var _style, _path, _path2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlacemnetExpert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ff6868}.st1{fill:#858186}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.2 29h-3.3c-.3 0-.5-.2-.6-.5l-1.1-4.4c-.1-.3.1-.5.4-.5.3-.1.7-.1.7.2l1 4h2.4l1-4c.1-.3.3 0 .6.1s.6-.1.5.2l-1.1 4.4c.1.3-.2.5-.5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4 38h-5.6c-.2 0-.3-.1-.5-.2-.1-.1-.2-.3-.1-.5l1.1-9c0-.3.3-.5.6-.5h3.3c.3 0 .6.2.6.5l1.1 9c0 .2 0 .3-.1.5s-.3.2-.4.2zm-4.9-1h4.2l-1-8h-2.3l-.9 8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.6 21.9c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm0-10.8c-2.6 0-4.8 2.2-4.8 4.8 0 2.6 2.2 4.8 4.8 4.8 2.6 0 4.8-2.2 4.8-4.8 0-2.6-2.2-4.8-4.8-4.8zM47.4 38.1H30.5c-.3 0-.6-.3-.6-.6s.3-.6.6-.6h16.2v-4.8c0-3.6-1.9-6.9-4.9-8.7-3 2.2-7.5 2.2-10.5 0-.7.4-1.3.9-1.9 1.5-1.2 1.2-3 4.1-4.9 8.2-.1.3-.1-.4-.4-.5s-.8.3-.7 0c1.4-2.9 3.4-6.8 5.1-8.5.8-.8 1.6-1.4 2.6-1.9.2-.1.5-.1.7.1 2.7 2.1 6.9 2.1 9.6 0 .2-.2.5-.2.7-.1 3.6 2 5.9 5.8 5.9 9.9v5.4c0 .3-.3.6-.6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.6 38.1H30.5c-.2 0-.3-.1-.4-.2s-.2-.3-.2-.4v-4.6l-3.1 4.9c-.1.2-.3.3-.5.3H26c-.3 0-.6-.3-.6-.6s.2-.6.5-.6l4.1-6.4c.1-.2.4-.3.7-.3.3.1.4.3.4.6v6.1h10.8v-6.1c0-.3.3-.6.6-.6s.6.3.6.6v6.7c.1.3-.2.6-.5.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.3 21.9c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6c.1 3.3-2.6 6-6 6zm0-10.8c-2.6 0-4.8 2.2-4.8 4.8 0 2.6 2.2 4.8 4.8 4.8s4.8-2.2 4.8-4.8c0-2.6-2.1-4.8-4.8-4.8zM26 38.1h-4.4c-.2 0-.4-.1-.5-.3L18 32.9v4.6c0 .3-.3.6-.6.6H.6c-.3 0-.6-.3-.6-.6v-5.4c0-4.1 2.3-7.9 5.9-9.9.2-.1.5-.1.7.1C8 23.4 9.7 24 11.4 24c1.8 0 3.4-.6 4.8-1.7.2-.2.5-.2.7-.1.9.5 1.8 1.1 2.6 1.9 1.7 1.7 3.7 5.6 5.1 8.5 1.2 2.5 2.1 4.6 2.1 4.7.1.2.1.4-.1.6-.2.1-.4.2-.6.2zm-4-1.3h3.2c-.4-.8-1-2.2-1.7-3.8-1.9-4-3.7-6.9-4.9-8.2-.6-.6-1.3-1.2-2-1.2-1.5 1.1-3.3 1.7-5.2 1.7s-3.7-.6-5.3-1.7c-3 1.8-4.8 4.8-4.8 8.4v4.8h15.6v-6.1c0-.3.2-.5.4-.6.3-.1.5 0 .7.3l4 6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.3 38.1c-.3 0-.6-.3-.6-.6v-6.7c0-.3.3-.6.6-.6s.6.3.6.6v6.7c0 .3-.2.6-.6.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacemnetExpert);
export default __webpack_public_path__ + "static/media/placemnetExpert.c718d4a88ee17ad7e6d38e46736639f5.svg";
export { ForwardRef as ReactComponent };